import {useQuery} from "react-query"
import useAuth from "auth/useAuth"

export default function useShiftPermissions(area) {

    const {auth, API} = useAuth()

    const query = useQuery(
        ["shift-permissions", area],
        () => auth(API.shiftsAreaPermissionsGet, {area}).then(response => response.data),
        {enabled: !!area}
    )

    return {...query, permissions: query.data ?? {}}
}
